import { useEffect, useMemo, useRef } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { useGetVideosByNetworkAndCategoryQuery } from "../../services/modulesuser/category";
import { setVideosByKey } from "../../store/video";
import { titleToKey } from "../../services/utils/helpers.js";

import Loader from "../../component/ui/Loader.js";
import Heading from "../../component/ui/Heading.js";
import ButtonsPreview from "../../component/previews/ButtonsPreview.js";
import PreviewImage from "../../component/previews/PreviewImage.js";

import useSwipeScroll from "../../hooks/useSwipeScroll.js";

function VideoItemHorizontal({ title, categoryId }) {
  const dispatch = useDispatch();
  const rowRef = useRef(null);

  // drag mouse + swipe touch; wheel verticale -> scroll orizzontale
  useSwipeScroll(rowRef, { enableWheelX: true, threshold: 12 });

  const { data, isLoading, error } = useGetVideosByNetworkAndCategoryQuery({ categoryId });
  //const videos = Array.isArray(data) ? data : [];
  const videos = useMemo(() => {
    const list = Array.isArray(data) ? [...data] : [];
    return list.sort(() => Math.random() - 0.5);
  }, [data]);

  useEffect(() => {
    dispatch(setVideosByKey({ key: titleToKey(title), videos: data || [], title }));
  }, [dispatch, title, data]);

  if (isLoading) return <Loader />;
  if (error || !videos.length) return null;

  return (
    <section>
      <Heading>{title}</Heading>

      <div className="relative">
        {/* Importante: assicurati che gli overlay interni usino pointer-events-none,
           e solo i bottoni abbiano pointer-events-auto */}
        <ButtonsPreview ribbon={rowRef} length={videos.length} isScrollByOne />

        <div
          data-xscroll
          ref={rowRef}
          className="overflow-x-auto scrollbar-hide scroll-smooth mt-3 cursor-grab select-none"
          style={{ WebkitOverflowScrolling: "touch", overscrollBehaviorX: "contain" }}
        >
          {/* Grid orizzontale: Safari-safe */}
          <div className="grid grid-flow-col grid-rows-1 auto-cols-[320px] gap-x-[14px] gap-y-6">
            {videos.map((video) => (
              <div key={video.id} className="w-[320px] min-w-[320px]">
                <Link
                  to={`/videos/${video.id}`}
                  state={{ video }}
                  className="block pointer-events-auto relative z-10 w-full"
                  style={{ width: 320, WebkitTransform: "translateZ(0)" }}
                >
                  <PreviewImage media={video} type="tv" hud={true} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default VideoItemHorizontal;
